var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProjectSetUp = function SvgProjectSetUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "07.-Minc-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Menu",
    transform: "translate(-710.000000, -666.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Navigation-Bar-/-HealthScreening",
    transform: "translate(690.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Health-Screening-List",
    transform: "translate(0.000000, 353.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 6,
    transform: "translate(0.000000, 300.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left-Copy",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,6 L16,6 L16,4 C16,2.9 15.1,2 14,2 L10,2 C8.9,2 8,2.9 8,4 L8,6 L4,6 C2.9,6 2,6.9 2,8 L2,20 C2,21.1 2.9,22 4,22 L20,22 C21.1,22 22,21.1 22,20 L22,8 C22,6.9 21.1,6 20,6 Z M10,4 L14,4 L14,6 L10,6 L10,4 Z M16,15 L13,15 L13,18 L11,18 L11,15 L8,15 L8,13 L11,13 L11,10 L13,10 L13,13 L16,13 L16,15 Z",
    id: "Shape",
    fill: "#F6F7FA"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProjectSetUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/project-set-up.76dc0a35.svg";
export { ForwardRef as ReactComponent };